import { render, staticRenderFns } from "./favorite-list-item.vue?vue&type=template&id=2262a806&scoped=true"
import script from "./favorite-list-item.vue?vue&type=script&lang=js"
export * from "./favorite-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262a806",
  null
  
)

export default component.exports